import { useTranslation } from "react-i18next";
import IconNewFile from "../../layout/others/icon_new_file.svg";
import IconEducation from "../../layout/tabs_icons/icon_tabs_education_active.svg";
import IconWork from "../../layout/tabs_icons/icon_tabs_work_active.svg";
import IconSkills from "../../layout/tabs_icons/icon_tabs_skills_active.svg";
import StepCircle from "./StepCircle";
import StepLine from "./StepLine";
import "./styles.scss";
import { useEffect, useState } from "react";

const ProgressBar = ({
  currentStep,
  setCurrentStep,
  showWelcomeCircle,
  showUploadDocument,
  checkPersonalInfoErrors,
  checkEducationErrors,
  checkWorkExpErrors,
  checkTechSkillsErrors
}) => {
  const { t } = useTranslation();

  const [personalInfoErrorsState, setPersonalInfoErrorsState] = useState({
    completionState: "pending"
  });
  const [educationErrorsState, setEducationErrorsState] = useState({
    completionState: "pending"
  });
  const [techSkillsErrorsState, setTechSkillsErrorsState] = useState({
    completionState: "pending"
  });
  const [workExpErrorsState, setWorkExpErrorsState] = useState({
    completionState: "pending"
  });

  const isPersonalInfoErrors =
    Object.keys(checkPersonalInfoErrors()).length === 0 ? false : true;
  const isEducationErrors =
    Object.keys(checkEducationErrors()).length === 0 ? false : true;
  const isTechSkillErrors =
    Object.keys(checkTechSkillsErrors()).length === 0 ? false : true;
  const isWorkErrors =
    Object.keys(checkWorkExpErrors()).length === 0 ? false : true;

  useEffect(() => {
    if (currentStep > 4) {
      setPersonalInfoErrorsState({
        completionState: isPersonalInfoErrors ? "withErrors" : "complete",
        ...checkPersonalInfoErrors()
      });
      setEducationErrorsState({
        completionState: isEducationErrors ? "withErrors" : "complete",
        ...checkEducationErrors()
      });
      setWorkExpErrorsState({
        completionState: isWorkErrors ? "withErrors" : "complete",
        ...checkWorkExpErrors()
      });
      setTechSkillsErrorsState({
        completionState: isTechSkillErrors ? "withErrors" : "complete",
        ...checkTechSkillsErrors()
      });
    } else if (currentStep > 3) {
      setPersonalInfoErrorsState({
        completionState: isPersonalInfoErrors ? "withErrors" : "complete",
        ...checkPersonalInfoErrors()
      });
      setEducationErrorsState({
        completionState: isEducationErrors ? "withErrors" : "complete",
        ...checkEducationErrors()
      });
      setWorkExpErrorsState({
        completionState: isWorkErrors ? "withErrors" : "complete",
        ...checkWorkExpErrors()
      });
    } else if (currentStep > 2) {
      setPersonalInfoErrorsState({
        completionState: isPersonalInfoErrors ? "withErrors" : "complete",
        ...checkPersonalInfoErrors()
      });
      setEducationErrorsState({
        completionState: isEducationErrors ? "withErrors" : "complete",
        ...checkEducationErrors()
      });
    } else if (currentStep > 1) {
      setPersonalInfoErrorsState({
        completionState: isPersonalInfoErrors ? "withErrors" : "complete",
        ...checkPersonalInfoErrors()
      });
    }
  }, [
    currentStep,
    checkEducationErrors,
    checkPersonalInfoErrors,
    checkTechSkillsErrors,
    checkWorkExpErrors,
    isWorkErrors,
    isEducationErrors,
    isPersonalInfoErrors,
    isTechSkillErrors
  ]);

  return (
    <header className="prog-bar-container">
      <div>
        {showWelcomeCircle && (
          <StepCircle
            imgSrc={IconNewFile}
            complete={currentStep > 0}
            title={t("Welcome")}
            onClick={() => setCurrentStep(1)}
          />
        )}
        {showWelcomeCircle && <StepLine complete={currentStep > 1} />}
        <StepCircle
          imgSrc={IconNewFile}
          complete={currentStep > 1}
          title={t("Personal Information")}
          onClick={() => setCurrentStep(2)}
          completionState={personalInfoErrorsState.completionState}
        />
        <StepLine complete={currentStep > 2} />
        <StepCircle
          imgSrc={IconEducation}
          complete={currentStep > 2}
          title={t("Education and training")}
          onClick={() => setCurrentStep(3)}
          completionState={educationErrorsState.completionState}
        />
        <StepLine complete={currentStep > 3} />
        <StepCircle
          imgSrc={IconWork}
          complete={currentStep > 3}
          title={t("Work Experience")}
          onClick={() => setCurrentStep(4)}
          completionState={workExpErrorsState.completionState}
        />
        <StepLine complete={currentStep > 4} />
        <StepCircle
          imgSrc={IconSkills}
          complete={currentStep > 4}
          title={t("Tech skills")}
          onClick={() => setCurrentStep(5)}
          completionState={techSkillsErrorsState.completionState}
        />
        {showUploadDocument && <StepLine complete={currentStep > 5} />}
        {showUploadDocument && (
          <StepCircle
            imgSrc={IconNewFile}
            complete={currentStep > 5}
            title={t("Upload documents")}
            onClick={() => setCurrentStep(6)}
          />
        )}
      </div>
    </header>
  );
};

export default ProgressBar;
